import { render, staticRenderFns } from "./InvoiceSettings.vue?vue&type=template&id=2ba8d4c9&scoped=true&lang=pug&"
import script from "./InvoiceSettings.vue?vue&type=script&lang=ts&"
export * from "./InvoiceSettings.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceSettings.vue?vue&type=style&index=0&id=2ba8d4c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba8d4c9",
  null
  
)

export default component.exports